import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import I18n from '@/rI18n';
import { updateProjectDetail, getProjectListInCorporation, handleUpdateProjectResource } from '@/service/projectService';
import { getAllTicketInCustomerAndHelpdeskSide } from '@/service/ticketService';
import { getFormListCreatedByProject } from '@/service/formManagementService';
import { cloneDeep, isEqual } from 'lodash';

export const newProjectDefaultData = {
    id: Date.now().toString(),
    projectName: '',
    desk: Constant.DESK.OFF,
    public: Constant.PUBLIC.OFF,
    errors: ''
};

export const addNewProject = argsAll => {
    let projectAddListClone = cloneDeep(argsAll.projectAddList);
    if (projectAddListClone.length === 1) {
        return;
    }
    let newProject = { ...newProjectDefaultData };
    newProject.id = Date.now().toString();

    projectAddListClone.push(newProject);
    argsAll.setProjectAddList(projectAddListClone);
};

export const onRemoveProject = (projectId, argsAll) => {
    let projectAddListClone = cloneDeep(argsAll.projectAddList);
    let listEditProjectClone = cloneDeep(argsAll.listEditProject);
    const indexAddProject = Utils.findIndexInArrayById(projectId, projectAddListClone);

    projectAddListClone.splice(indexAddProject, 1);

    const resultArray = Object.keys(listEditProjectClone).map(index => {
        let projectItem = listEditProjectClone[index];
        projectItem.id = index;
        return projectItem;
    });
    let nameDuplicate = findNameDuplicate(resultArray, projectAddListClone);
    for (let project in listEditProjectClone) {
        if (
            listEditProjectClone[project].error === I18n.get('USER03MSG001') &&
            !nameDuplicate.includes(listEditProjectClone[project].name.trim())
        ) {
            listEditProjectClone[project].error = '';
        }
    }
    argsAll.setListEditProject(listEditProjectClone);
    argsAll.setProjectAddList(projectAddListClone);
};

export const onChangeProjectName = (event, projectId, argsAll) => {
    let textValue = event.target.value;
    let projectAddListClone = cloneDeep(argsAll.projectAddList);
    let listEditProjectClone = cloneDeep(argsAll.listEditProject);
    let errors = '';
    const indexAddProject = Utils.findIndexInArrayById(projectId, projectAddListClone);

    if (Utils.isEmptyString(textValue.trim())) {
        errors = I18n.get('USER03MSG002');
        projectAddListClone[indexAddProject].projectName = textValue;
        projectAddListClone[indexAddProject].errors = errors;
        const resultArray = Object.keys(listEditProjectClone).map(index => {
            let projectItem = listEditProjectClone[index];
            projectItem.id = index;
            return projectItem;
        });
        let nameDuplicate = findNameDuplicate(resultArray, projectAddListClone);
        for (let project in listEditProjectClone) {
            if (
                listEditProjectClone[project].error === I18n.get('USER03MSG001') &&
                !nameDuplicate.includes(listEditProjectClone[project].name.trim())
            ) {
                listEditProjectClone[project].error = '';
            }
        }
        argsAll.setListEditProject(listEditProjectClone);
        return argsAll.setProjectAddList(projectAddListClone);
    }

    let flag = false;

    for (let project in listEditProjectClone) {
        if (listEditProjectClone[project].name.trim() === textValue.trim()) {
            errors = I18n.get('USER03MSG001');
            flag = true;
            break;
        }
    }

    if (!flag) {
        const resultArray = Object.keys(listEditProjectClone).map(index => {
            let projectItem = listEditProjectClone[index];
            projectItem.id = index;
            return projectItem;
        });
        let nameDuplicate = findNameDuplicate(resultArray, projectAddListClone);
        for (let project in listEditProjectClone) {
            if (
                listEditProjectClone[project].error === I18n.get('USER03MSG001') &&
                !nameDuplicate.includes(listEditProjectClone[project].name.trim())
            ) {
                listEditProjectClone[project].error = '';
            }
        }
        argsAll.setListEditProject(listEditProjectClone);
    }

    projectAddListClone[indexAddProject].projectName = textValue;
    projectAddListClone[indexAddProject].errors = errors;
    argsAll.setProjectAddList(projectAddListClone);
};

export const onChangeProjectServiceType = (index, e, projectId, argsAll) => {
    let projectServiceType = e.target.value;
    let isDesk = Constant.DESK.OFF;
    let isPublic = Constant.PUBLIC.OFF;
    let projectAddListClone = cloneDeep(argsAll.projectAddList);
    const indexAddProject = Utils.findIndexInArrayById(projectId, projectAddListClone);

    if (projectServiceType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF) {
        isDesk = Constant.DESK.ON;
    }
    if (projectServiceType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON) {
        isDesk = Constant.DESK.ON;
        isPublic = Constant.PUBLIC.ON;
    }

    projectAddListClone[indexAddProject].desk = isDesk;
    projectAddListClone[indexAddProject].public = isPublic;

    argsAll.setProjectAddList(projectAddListClone);
};

export const validateListEditProject = async argsAll => {
    let isError = false;
    let listEditProject = cloneDeep(argsAll.listEditProject);
    let listAllProjectInCorp = await getProjectListInCorporation(argsAll.API, argsAll.corporationDetail.id);

    for (let projectId of Object.keys(listEditProject)) {
        let projectUpdateData = listEditProject[`${projectId}`];
        let projectByName = listAllProjectInCorp.find(project => {
            let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name);
            return projectUpdateData.name?.trim() === projectName
        })

        if (!Utils.isEmptyObject(projectByName) && projectByName.id !== projectId) {
            isError = true;
            listEditProject[`${projectId}`].error = I18n.get('USER03MSG001');
        }
    }

    if (isError) {
        argsAll.setListEditProject(listEditProject);
        throw new Error(I18n.get('USER03MSG001'));
    }
};

export const handleSubmitListProject = async(argsAll) => {
    if(Utils.isEmptyObject(argsAll.listEditProject) && Utils.isEmptyArray(argsAll.projectAddList)) {
        return;
    }

    try {
        argsAll.setIsLoading(true);

        // Validate update project
        if(!Utils.isEmptyObject(argsAll.listEditProject)) {
            // validate edit project
            await validateListEditProject(argsAll);
        }

        let listProjectClone = cloneDeep(argsAll.listProject);
        let listProjectInCorpClone = cloneDeep(argsAll.listProjectInCorp);
        let listProjectOfUserClone = cloneDeep(argsAll.listProjectOfUser)
        let newProjectResult = {};
        let updateProjectResult = [];
        
        let requestUpdateParams = {
            method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.CREATE_AND_EDIT_PROJECT,
            corporationId: argsAll.corporationDetail.id,
            userId: argsAll.userDetail.id,
        }

        // handle params create project
        if(!Utils.isEmptyArray(argsAll.projectAddList)) {
            let projectAddListParams = [];
            argsAll.projectAddList.forEach(projectAdd => {
                projectAddListParams.push({
                    name: projectAdd.projectName.trim(),
                    isDesk: projectAdd.desk,
                    isPublic: projectAdd.public,
                })
            })
            requestUpdateParams.addNewList = projectAddListParams;

            // newProjectResult = await handleSubmitCreateProject(argsAll);
            // if(!Utils.isEmptyObject(newProjectResult)) {
            //     listProjectClone.push({...newProjectResult, isProjectManager: true});
            //     listProjectInCorpClone.push({...newProjectResult, isProjectManager: true});
            //     listProjectOfUserClone.push({...newProjectResult, isProjectManager: true});
            // }
        }

        if (!Utils.isEmptyObject(argsAll.listEditProject)) {
            let updateProjectList = [];
            for (let projectId of Object.keys(argsAll.listEditProject)) {
                let projectUpdateData = argsAll.listEditProject[`${projectId}`];
        
                let updateData = {
                    id: projectId,
                    name: projectUpdateData.name.trim(),
                    isDesk: projectUpdateData.desk,
                    isPublic: projectUpdateData.public
                }
                updateProjectList.push(updateData);
            }
            requestUpdateParams.editList = updateProjectList;
        }

        // Handle add new and edit project
        let updateResult = await handleUpdateProjectResource(argsAll.API, requestUpdateParams);
        if (!updateResult || !updateResult.status) {
            argsAll.setIsLoading(false);
            if (updateResult.errorMessage) {
                argsAll.enqueueSnackbar(I18n.get(`${updateResult.errorMessage}`), {
                    variant: 'error',
                    autoHideDuration: 3000
                });
            }
            return;
        }
        let updateResultData = Utils.convertJSONDataToObject(updateResult.data);

        if(!Utils.isEmptyArray(updateResultData.addNewList)) {
            newProjectResult = updateResultData.addNewList[0];
            listProjectClone.push({...newProjectResult, isProjectManager: true});
            listProjectInCorpClone.push({...newProjectResult, isProjectManager: true});
            listProjectOfUserClone.push({...newProjectResult, isProjectManager: true});

            // add new project id to usingProjects property of system forms which will be in active list
            const listForm = cloneDeep(argsAll.listForm);
            listForm.map(form => {
                if (
                    [
                        Constant.FORM_TYPE.FILE_FORMAT,
                        Constant.FORM_TYPE.PAGE_FORMAT,
                        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK,
                        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER,
                        Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK,
                        Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST,
                        Constant.FORM_TYPE.FORM_REQ_QA,
                        Constant.FORM_TYPE.EMAIL_FORMAT,
                        Constant.FORM_TYPE.FORM_KNOWLEDGE
                    ].includes(form.type) &&
                    form.definition === Constant.FORM_DEFINITION.SYSTEM
                ) {
                    let orderClone = Utils.convertJSONDataToObject(form.order);
                    if (typeof orderClone === 'string') {
                        orderClone = Utils.convertJSONDataToObject(orderClone);
                    }
                    switch(form.type) {
                        case Constant.FORM_TYPE.FORM_KNOWLEDGE:
                            if (form.definition === Constant.FORM_DEFINITION.SYSTEM && form.promptKnowledgeFormFlag === Constant.PROMPT_FLAG.TRUE) {
                                orderClone[newProjectResult.id] = Constant.SYSTEM_FORM_ORDER.FORM_AI_CHAT_PROMPT;
                            }
                            break;
                        case Constant.FORM_TYPE.EMAIL_FORMAT:
                            orderClone[newProjectResult.id] = Constant.SYSTEM_FORM_ORDER.EMAIL_FORMAT;
                            break;
                        case Constant.FORM_TYPE.FILE_FORMAT:
                            orderClone[newProjectResult.id] = 1;
                            break;
                        case Constant.FORM_TYPE.PAGE_FORMAT:
                            orderClone[newProjectResult.id] = 2;
                            break;
                        case Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
                            orderClone[newProjectResult.id] = 3;
                            break;
                        case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
                            orderClone[newProjectResult.id] = 4;
                            break;
                        case Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
                            orderClone[newProjectResult.id] = 5;
                            break;
                        case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
                            orderClone[newProjectResult.id] = 6;
                            break;
                        case Constant.FORM_TYPE.FORM_REQ_QA:
                            orderClone[newProjectResult.id] = 7;
                            break;
                        default:
                            break;
                    }

                    form.order = JSON.stringify(orderClone);
                    form.usingProjects.push(newProjectResult.id);
                    return form;
                }
                return form;
            });
            argsAll.setListForm(listForm);
        }

        // handle update project
        if(!Utils.isEmptyArray(updateResultData.editList)) {
            updateProjectResult = updateResultData.editList;
            // updateProjectResult = await handleSubmitEditProjectList(argsAll);

            if(!Utils.isEmptyArray(updateProjectResult)) {
                // update project inuse
                let indexProjectInuseUpdate = Utils.findIndexInArrayById(argsAll.projectInuseDetail.id, updateProjectResult);
                if(indexProjectInuseUpdate !== -1) {
                    let projectInuseUpdateResult = updateProjectResult[indexProjectInuseUpdate];
                    let projectDetailClone = cloneDeep(argsAll.projectInuseDetail);
                    projectDetailClone.name = projectInuseUpdateResult.name;
                    projectDetailClone.isDesk = projectInuseUpdateResult.isDesk;
                    projectDetailClone.isPublic = projectInuseUpdateResult.isPublic;
                    // Reset ip setting when project is not public
                    if (!projectInuseUpdateResult?.isPublic) {
                        let ipAddressSetting = {
                            usingIpAddressRestrict: false,
                            ipAddressRange: ''
                        }
                        let projectSetting = Utils.convertJSONDataToObject(projectDetailClone?.projectSetting);
                        projectDetailClone.projectSetting = JSON.stringify({ ...projectSetting, ipAddressSetting: ipAddressSetting });
                    }
                    argsAll.setProjectInuseDetail(projectDetailClone);
                }

                listProjectClone.forEach(project => {
                    let projectUpdate = updateProjectResult.find(p => p.id === project.id);
                    if(!Utils.isEmptyObject(projectUpdate)) {
                        project.name = projectUpdate.name;
                        project.isDesk = projectUpdate.isDesk;
                        project.isPublic = projectUpdate.isPublic;
                        // Reset ip setting when project is not public
                        if (!projectUpdate?.isPublic) {
                            let ipAddressSetting = {
                                usingIpAddressRestrict: false,
                                ipAddressRange: ''
                            }
                            let projectSetting = Utils.convertJSONDataToObject(project?.projectSetting);
                            project.projectSetting = JSON.stringify({ ...projectSetting, ipAddressSetting: ipAddressSetting });
                        }
                    }
                })
    
                listProjectInCorpClone.forEach(project => {
                    let projectUpdate = updateProjectResult.find(p => p.id === project.id);
                    if(!Utils.isEmptyObject(projectUpdate)) {
                        project.name = projectUpdate.name;
                        project.isDesk = projectUpdate.isDesk;
                        project.isPublic = projectUpdate.isPublic;
                        // Reset ip setting when project is not public
                        if (!projectUpdate?.isPublic) {
                            let ipAddressSetting = {
                                usingIpAddressRestrict: false,
                                ipAddressRange: ''
                            }
                            let projectSetting = Utils.convertJSONDataToObject(project?.projectSetting);
                            project.projectSetting = JSON.stringify({ ...projectSetting, ipAddressSetting: ipAddressSetting });
                        }
                    }
                })

                if (argsAll.isAdmin) {
                    listProjectOfUserClone.forEach(project => {
                        let projectUpdate = updateProjectResult.find(p => p.id === project.id);
                        if(!Utils.isEmptyObject(projectUpdate)) {
                            project.name = projectUpdate.name;
                            project.isDesk = projectUpdate.isDesk;
                            project.isPublic = projectUpdate.isPublic;
                            // Reset ip setting when project is not public
                            if (!projectUpdate?.isPublic) {
                                let ipAddressSetting = {
                                    usingIpAddressRestrict: false,
                                    ipAddressRange: ''
                                }
                                let projectSetting = Utils.convertJSONDataToObject(project?.projectSetting);
                                project.projectSetting = JSON.stringify({ ...projectSetting, ipAddressSetting: ipAddressSetting });
                            }
                        }
                    })
                }
            }
        }

        // update state list project
        listProjectClone = Utils.sortListByNameDictionaryASC(listProjectClone);
        argsAll.setListProject(listProjectClone);
        listProjectInCorpClone = Utils.sortListByNameDictionaryASC(listProjectInCorpClone);
        argsAll.setListProjectInCorp(listProjectInCorpClone);
        if (argsAll.isAdmin) {
            listProjectOfUserClone = Utils.sortListByNameDictionaryASC(listProjectOfUserClone);
            argsAll.setListProjectOfUser(listProjectOfUserClone);
        }
        argsAll.setProjectAddList([]);
        argsAll.setListEditProject({});
        argsAll.setInitListEditProject({});

        if (
            Utils.isEmptyArray(argsAll.projectAddList) &&
            !Utils.isEmptyArray(updateProjectResult)
        ) {
            argsAll.enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }

        if (
            Utils.isEmptyObject(argsAll.listEditProject) &&
            !Utils.isEmptyObject(newProjectResult)
        ) {
            argsAll.enqueueSnackbar(I18n.get('USER03MSG006'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }

        if (
            !Utils.isEmptyArray(argsAll.projectAddList) &&
            !Utils.isEmptyArray(updateProjectResult) &&
            !Utils.isEmptyObject(argsAll.listEditProject) &&
            !Utils.isEmptyObject(newProjectResult)
        ) {
            argsAll.enqueueSnackbar(I18n.get('COMMSG047'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }

        // argsAll.setIsLoading(false);
        window.location.reload();
    } catch (error) {
        console.log("handleSubmitListProject ~ error :>>", error)
        argsAll.setIsLoading(false);
    }
}

export const handleEditProject = (argsAll, project) => {
    let listEditProjectClone = cloneDeep(argsAll.listEditProject);
    let initListEditProject = cloneDeep(argsAll.initListEditProject);

    let item = {};
    item[`${project.id}`] = {
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name),
        desk: project.isDesk,
        public: project.isPublic,
        error:"",
        id: project.id
    };

    listEditProjectClone = { ...listEditProjectClone, ...item };
    initListEditProject = { ...initListEditProject, ...item };
    argsAll.setListEditProject(listEditProjectClone);
    argsAll.setInitListEditProject(initListEditProject);
};

export const isEmptyEditProject = argsAll => {
    let listEditProject = cloneDeep(argsAll.listEditProject);
    let initListEditProject = cloneDeep(argsAll.initListEditProject);

    if(isEqual(listEditProject, initListEditProject)) {
        return true;
    }
    return false;
}

export const isEmptyAddProject = argsAll => {
    let projectAddList = cloneDeep(argsAll.projectAddList);
    if(Utils.isEmptyArray(projectAddList)) {
        return true;
    }
    if(!projectAddList[0]?.projectName?.trim().length) {
        return true;
    }
    else {
        return false;
    }
}

export const handleCancelProject = (argsAll) => {
    if(isEmptyEditProject(argsAll) && isEmptyAddProject(argsAll)) {
        argsAll.setProjectAddList([])
        argsAll.setListEditProject({});
        argsAll.setInitListEditProject({});
        return;
    }
    return argsAll.setOpenCancelDialog(true);
}

export const onClickDeleteProject = async (argsAll, project) => {
    if(Utils.isEmptyObject(project)) return;

    argsAll.setIsLoading(true);
    let checkIsProjectCanDelete = true;
    let listForm =  await getFormListCreatedByProject(argsAll.API, argsAll.corporationDetail.id, project.id);

    if (listForm.length > 0) {
        for (let form of listForm) {
            if (form.usingTickets) {
                let usingTickets = JSON.parse(form.usingTickets);
                if (!Utils.isEmptyObject(usingTickets)) {
                    checkIsProjectCanDelete = false;
                    break;
                }
            }
        }
    }
    if (checkIsProjectCanDelete) {
        let ticketList = await getAllTicketInCustomerAndHelpdeskSide(argsAll.API, argsAll.corporationDetail.id, project.id);
        if (!Utils.isEmptyArray(ticketList)) {
            checkIsProjectCanDelete = false;
        }
    }
    

    argsAll.setIsProjectCanDelete(checkIsProjectCanDelete);
    argsAll.setIsLoading(false);

    argsAll.setDeleteProject(project);
    argsAll.setIsOpenConfirmDelete(true);
}

export const onClickConfirmDeleteProject = async (argsAll, project) => {
    argsAll.setIsOpenConfirmDelete(false);
    argsAll.setIsLoading(true);

    let deleteProjectParams = {
        method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.DELETE_PROJECT,
        corporationId: argsAll.corporationDetail.id,
        userId: argsAll.userDetail.id,
        projectId: project.id
    }

    let deleteResponse = await handleUpdateProjectResource(argsAll.API, deleteProjectParams);
    if (deleteResponse && deleteResponse.status) {
        // update state
        let listProject = cloneDeep(argsAll.listProject);
        let indexInListProject = Utils.findIndexInArrayById(project.id, listProject);
        if(indexInListProject !== -1) {
            listProject[indexInListProject].active = Constant.ACTIVE_FLAG.DELETED;
        }

        let listProjectInCorp = cloneDeep(argsAll.listProjectInCorp);
        let indexInListProjectInCorp = Utils.findIndexInArrayById(project.id, listProjectInCorp);
        if(indexInListProjectInCorp !== -1) {
            listProjectInCorp[indexInListProjectInCorp].active = Constant.ACTIVE_FLAG.DELETED;
        }

        let listEditProject = cloneDeep(argsAll.listEditProject);
        if(listEditProject.hasOwnProperty(project.id)) {
            delete listEditProject[project.id];
            argsAll.setListEditProject(listEditProject);
        }

        argsAll.setListProject(listProject);
        argsAll.setListProjectInCorp(listProjectInCorp);
    }

    argsAll.setDeleteProject({});
    argsAll.setIsLoading(false);
}

export const validateProjectName = (textValue, projectId, listEditProjectClone, argsAll) => {
    let error = '';
    if (!textValue?.trim()) {
        return I18n.get('USER03MSG002');
    }

    for (let item in listEditProjectClone) {
        if (
            (item !== projectId && listEditProjectClone[item].name.trim() === textValue) ||
            textValue === argsAll.projectAddList[0]?.projectName.trim()
        ) {
            return I18n.get('USER03MSG001');
        }
    }

    return error;
};

export const findNameDuplicate = (projectEditList, projectAddList) => {
    let valueArr = projectEditList.map(item => item.name.trim()).filter(item => !!item);
    const nameDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return nameDuplicate;
};

export const onClickConfirmCancelProject = argsAll => {
    argsAll.setOpenCancelDialog(false);
    argsAll.setProjectAddList([])
    argsAll.setListEditProject({});
    argsAll.setInitListEditProject({})
}

export const checkIsEditProject = argsAll => {
    let listEditProject = cloneDeep(argsAll.listEditProject);
    let initListEditProject = cloneDeep(argsAll.initListEditProject);

    if(isEqual(listEditProject, initListEditProject)) {
        return false;
    }
    else {
        for(let project in listEditProject) {
            if(listEditProject[project].error.length > 0) {
                return false;
            }
        }
        return true;
    }
}

export const checkIsAddProject = argsAll => {
    let projectAddList = cloneDeep(argsAll.projectAddList);

    for(let project of projectAddList) {
        if(!project.projectName?.trim() || project.errors) {
            return false;
        }
    }
    return true;
}
export const checkDisableBtnSubmit = argsAll => {
    if(Utils.isEmptyArray(argsAll.projectAddList) && Utils.isEmptyObject(argsAll.listEditProject)) {
        return argsAll.setIsDisableBtnSubmit(true);
    }

    if(!Utils.isEmptyArray(argsAll.projectAddList)) {
        if(checkIsAddProject(argsAll)) {
            argsAll.setIsDisableBtnSubmit(false);
        }
        else {
            return argsAll.setIsDisableBtnSubmit(true);
        }
    }
    
    if(!Utils.isEmptyObject(argsAll.listEditProject)) {
        if(checkIsEditProject(argsAll)) {
            argsAll.setIsDisableBtnSubmit(false);
        }
        else {
            return argsAll.setIsDisableBtnSubmit(true);
        }
    }
}

export const onChangeEditProjectName = (event, projectId, argsAll) => {
    let textValue = event.target.value;
    let error = '';
    let listEditProjectClone = cloneDeep(argsAll.listEditProject);
    let projectAddListClone = cloneDeep(argsAll.projectAddList);
    error = validateProjectName(textValue.trim(), projectId, listEditProjectClone, argsAll);

    listEditProjectClone[`${projectId}`] = {
        ...listEditProjectClone[`${projectId}`],
        name: textValue,
        error: error
    };

    const resultArray = Object.keys(listEditProjectClone).map(index => {
        let projectItem = listEditProjectClone[index];
        projectItem.id = index;
        return projectItem;
    });

    let nameDuplicate = findNameDuplicate(resultArray, projectAddListClone);

    let valueAdd = projectAddListClone.length && projectAddListClone[0]?.projectName.trim();

    let isNameAddDuplicate = resultArray.some(e => e.name.trim() === valueAdd);
    if (
        !isNameAddDuplicate &&
        projectAddListClone.length &&
        projectAddListClone[0]?.errors === I18n.get('USER03MSG001')
    ) {
        projectAddListClone[0].errors = '';
        argsAll.setProjectAddList(projectAddListClone);
    }

    resultArray.forEach(item => {
        if (!nameDuplicate.includes(item.name.trim()) && item.error === I18n.get('USER03MSG001')) {
            if (
                projectAddListClone.length &&
                item.name.trim() !== projectAddListClone[0]?.projectName.trim()
            ) {
                listEditProjectClone[`${item.id}`].error = '';
            }
        }
    });

    argsAll.setListEditProject(listEditProjectClone);
};

export const onChangeEditProjectServiceType = (index, event, projectId, argsAll) => {
    let projectServiceType = event.target.value;
    let isDesk = Constant.DESK.OFF;
    let isPublic = Constant.PUBLIC.OFF;
    if (projectServiceType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_OFF) {
        isDesk = Constant.DESK.ON;
    }
    if (projectServiceType === Constant.PROJECT_SERVICE_TYPE.DESK_ON_PUBLIC_ON) {
        isDesk = Constant.DESK.ON;
        isPublic = Constant.PUBLIC.ON;
    }
    let listEditProjectClone = cloneDeep(argsAll.listEditProject);
    listEditProjectClone[`${projectId}`] = {
        ...listEditProjectClone[`${projectId}`],
        desk: isDesk,
        public: isPublic
    };
    argsAll.setListEditProject(listEditProjectClone);
};

export const onClickCloseTab = (args) => {
    let currentPanelInfo = Utils.getPanelInfo(args.panelId, args.panelList);
    if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
    args.closePanelTab({
        event: null,
        panelType: currentPanelInfo.type,
        panelId: args.panelId,
        tabId: args.tabId
    });
} 

export const getPermissionCreateProject = (isAdmin, currentContractType) => {
    if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(currentContractType)) {
        return false;
    }
    return isAdmin;
};

export const getPermissionEditProject = (isAdmin,projectType,isProjectManager,currentContractType) =>{

    if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(currentContractType)) {
        return false;
    }

    //can not edit base and guest customer project,base project, guest project
    if([Constant.PROJECT_TYPE.CUSTOMER,Constant.PROJECT_TYPE.BASE].includes(projectType)){
        return false
    }
    // admin and pm has permission edit project
    if(!isAdmin && !isProjectManager){
        return false
    }
    return true
}

export const getPermissionDeleteProject = (isAdmin,projectType,isProjectManager,currentContractType) =>{

    if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(currentContractType)) {
        return false;
    }

    //can not delete base and guest customer project,base project, guest project
    if([Constant.PROJECT_TYPE.CUSTOMER,Constant.PROJECT_TYPE.BASE].includes(projectType)){
        return false
    }
    // admin and pm has permission delete project
    if(!isAdmin && !isProjectManager){
        return false
    }
    return true
}